module.exports = __webpack_public_path__ + "img/Index1.b2f18b9c.png";